import React, {createRef} from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import TabbedPane from '../../components/plain/TabbedPane';
import LabelField from '../../components/plain/LabelField';
import FieldString from '../../components/plain/FieldString';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldDate from '../../components/plain/FieldDate';
import FieldList_Reference from '../../components/plain/FieldList_Reference';

import TabAPNames from './components/TabAPNames';
import TabAPImages from './components/TabAPImages';
import TabAPEvents from './components/TabAPEvents';
import TabAPSources from './components/TabAPSources';
import FieldGlobalId from './components/FieldGlobalId';

import {getLanguage} from '../../util/localStorage';
import {
	FORM_AUTHORITY_PUBLISHER_PLAIN, FORM_PROVIDER_TABLE, FORM_ORGANIZATION_TABLE, FORM_CONTACT_TABLE
} from '../../util/consts/forms';
import { CLASS_PROVIDER, CLASS_ORGANIZATION, CLASS_CONTACT } from '../../util/consts/classes';
import { PROVIDER_PATH, ORGANIZATION_PATH, CONTACT_PATH } from '../../util/routes';
import { ENUMERATION_LANGUAGE, } from '../../util/consts/common';

class AuthorityPublisherPlainPage extends PlainPage {

	enumLanguage = null;

	constructor(props) {
		super(props);
		this.formPath = FORM_AUTHORITY_PUBLISHER_PLAIN;
		this.formTitle = 'Бренд (видавництво)';
		this.buildInstanceCard = this.buildPublisherCard;
	}
	componentDidMount = async () => {
		this.init('AuthorityPublisher')
		document.title = 'BOM. ' + this.formTitle;
	}
	async completeInit() {
		this.enumLanguage = this.realm.getEnumeration( ENUMERATION_LANGUAGE );
		
		return true;
	}
	buildPublisherCard = (publisherInstance) => {
		let card = '';
		let currentLanguage = getLanguage();
		let name = null;
		for(let n of publisherInstance.rootField.value.name.value) {
			if( n.value.language.value == currentLanguage && n.value.name.value ) {
				name = n;
				break;
			}
		}
		if( name == null && publisherInstance.rootField.value.name.value.length > 0)
			name = publisherInstance.rootField.value.name.value[0];
		if( name != null  && name.value.name.value ) {
			card += name.value.name.value;
		} 
		return card;
	}
	createInstanceFromBean(bean) {
		let instance = super.createInstanceFromBean(bean);
	
		if( instance.id == null ) {
			instance.globalId = 'ua.ubi.pub.';
			instance.fieldGlobalId.value = instance.globalId; 
		}
		
		return instance;
	}

	createTab = (tabId) => {
		let readOnly = this.instanceReadOnly;
		if( tabId == 'names' )
			return <TabAPNames plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'images' )
			return <TabAPImages plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'events' )
			return <TabAPEvents plain={this} instance={this.state.instance} readOnly={readOnly} />;
		if( tabId == 'sources' )
			return <TabAPSources plain={this} instance={this.state.instance} readOnly={readOnly} />;
			
		return null;
	}

	renderBody() {
		let tabs = [
			{
				rowId: 'first',
				tabs: [
					{ tabId: 'names', tabTitle: 'Назви', },
					{ tabId: 'images', tabTitle: 'Зображення', },
					{ tabId: 'events', tabTitle: 'Події', },
					{ tabId: 'sources', tabTitle: 'Джерела', },
				]
			},
		];
		let readOnly = this.instanceReadOnly;
		let instance = this.state.instance;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
						<FieldGlobalId instance={instance} plain={this}
							readOnly={readOnly}
							styles={{ input: {minWidth: '250px', flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldEnum instance={instance} path={'/country'} plain={this} 
							readOnly={readOnly}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
						<FieldDate instance={instance} path={'/startDate'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldDate instance={instance} path={'/stopDate'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldString instance={instance} path={'/dates'} plain={this} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1', width: '100px'} }}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'start', marginBottom: '10px'}}>
						<FieldList_Reference path={'/owner'} instance={instance} plain={this} 
							styles={{divMain: {flexGrow: '1', marginRight: '30px' }}}
							labelEmptyToHeader={true}
							readOnly={readOnly}
							refNodes={[
								{
									classId: CLASS_ORGANIZATION, plainFormPath: ORGANIZATION_PATH, 
									selectInstanceFormId: FORM_ORGANIZATION_TABLE,
									selectInstanceFormTitle: 'Організації'
								},
								{
									classId: CLASS_CONTACT, plainFormPath: CONTACT_PATH, 
									selectInstanceFormId: FORM_CONTACT_TABLE,
									selectInstanceFormTitle: 'Фізичні особи'
								},
							]}
						/>
						<FieldList_Reference path={'/user'} instance={instance} plain={this} 
							styles={{divMain: {flexGrow: '1', }}}
							labelEmptyToHeader={true}
							readOnly={readOnly}
							refNodes={[
								{
									classId: CLASS_PROVIDER, plainFormPath: PROVIDER_PATH, 
									selectInstanceFormId: FORM_PROVIDER_TABLE,
									selectInstanceFormTitle: 'Постачальники'
								},
							]}
						/>
					</div>
					<TabbedPane tabs={tabs} createTab={this.createTab} 
						styles={{ divMain: {border: '1px solid gray', marginBottom: '15px'} }} 
					/>
					<div style={{marginBottom: '15px'}}>
						<LabelField instance={instance} path={'comment'} />
						<FieldString  instance={instance} path={'comment'} plain={this}
							multiline={true} rows={4} cols={60}
							readOnly={readOnly}
							styleInput={{width: '98%'}} ignoreTitle={true}
						 />
					</div>
				</div>
			</div>
		)
	}
}

export default AuthorityPublisherPlainPage;
